import * as actionTypes from './actionTypes';
import axios from '../../axios-orders';

export const addIngredient = (ingredient) => {
  return (dispatch, getState) => {
    dispatch({
      type: actionTypes.ADD_INGREDIENT,
      ingredient: ingredient
    })
  }
}

export const removeIngredient = (ingredient) => {
  return {
    type: actionTypes.REMOVE_INGREDIENT,
    ingredient: ingredient
  }
}

export const setIsBuilding = (isBuilding) => {
  return {
    type: actionTypes.SET_IS_BUILDING,
    isBuilding: isBuilding
  }
}

export const setBurgerData = (ingredients, totalPrice) => {
  if (!ingredients) {
    ingredients = {
      lettuce: 0,
      bacon: 0,
      cheese: 0,
      meat: 0
    }
  }
  return {
    type: actionTypes.SET_BURGER_DATA,
    ingredients: ingredients,
    totalPrice: totalPrice
  }
}

export const setServerBurgerData = (token, userId, ingredients) => {
  return dispatch => {
    axios.patch(`/users/${userId}/state/ingredients.json?auth=${token}`, ingredients)
      .then((response) => {
        if (!response) {
          throw new Error('Failed to update ingredients in Firebase')
        }
      })
      .catch((error) => {
        console.error(error.message);
      })
  }
}

export const getBurgerData = (token, userId) => {
  return (dispatch) => {
    axios.get(`/users/${userId}/state.json?auth=${token}`)
      .then((response) => {
        if (response.data) {
          let ingredients = response.data.ingredients;
          dispatch(setBurgerData(ingredients));
        } else {
          dispatch(initializeUserData(token, userId))
        }
      })
      .catch(error => {
        dispatch({ type: actionTypes.DISPLAY_PAGE_ERROR, error: error });
      })
  }
}

const initializeUserData = (token, userId) => {
  return dispatch => {
    const userData = {
      state: {
        nextID: 1,
        ingredients: {
          lettuce: 0,
          bacon: 0,
          cheese: 0,
          meat: 0
        }
      }
    }
    axios.patch(`/users/${userId}.json?auth=${token}`, userData)
      .then((response) => {
        dispatch(setBurgerData(response.data.state.ingredients, 4));
        dispatch({ type: actionTypes.SET_NEXT_ID, nextID: response.data.state.nextID });
      })
      .catch((error) => {
        console.error(error.message);
      })
  }
}


// WEBPACK FOOTER //
// ./src/store/actions/burgerBuilderActions.jsx